// src/hooks/useAuthGuard.js
import React, { useState, useRef, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from '../components/Auth/LoginModal';

export const useAuthGuard = () => {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const pendingActionRef = useRef(null);

  const requireAuth = useCallback((action) => {
    if (user) {
      action();
    } else {
      pendingActionRef.current = action;
      setShowModal(true);
    }
  }, [user]);

  const handleSuccess = useCallback(() => {
    setShowModal(false);
    if (pendingActionRef.current) {
      pendingActionRef.current();
      pendingActionRef.current = null;
    }
  }, []);

  const handleClose = useCallback(() => {
    setShowModal(false);
    pendingActionRef.current = null;
  }, []);

  const AuthModal = showModal ? (
    <LoginModal onClose={handleClose} onSuccess={handleSuccess} />
  ) : null;

  return { requireAuth, AuthModal };
};
